import { _post } from "../../../apiClient";
import { _showToast } from "../../../toastHelper";

const loadRazorpayScript = (src) => {
    return new Promise((resolve) => {
        const script = document.createElement("script");
        script.src = src;
        script.onload = () => {
            resolve(true);
        };
        script.onerror = () => {
            resolve(false);
        };
        document.body.appendChild(script);
    });
};


const createOrder = async (userId, packageId, quantity = 1) => {
    return await _post(`/app-user-packages`,
        {
            "appUserId": userId,
            "packageId": packageId,
            "quantity": quantity,
            "isForExtension": false
        })
        .then(response => {
            return response;
        })
        .catch(error => {
            _showToast(error, "error");
            return "failed";
        });
}


const processPayment = async (paymentData) => {
    return await _post(`/sales-orders/payment`,
        {
            "paymentId": paymentData.razorpay_payment_id,
            "orderId": paymentData.razorpay_order_id,
            "signature": paymentData.razorpay_signature
        })
        .then(response => {
            return true;
        })
        .catch(error => {
            _showToast(error, "error");
            return false;
        });

}

export { createOrder, loadRazorpayScript, processPayment };